export default {}

// Outer app routes
export const WEBSITE_URL = 'https://beyondpulse.com'
export const TERMS_URL = `${WEBSITE_URL}/:locale/terms`
export const PRIVACY_POLICY_URL = `${WEBSITE_URL}/:locale/privacy-policy`
